import { useFrame, useThree } from "@react-three/fiber";
import { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { useCanvasContext } from "../CanvasProvider";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import axios from "axios";
import { routes } from "routes";
import { useDispatch, useSelector, useStore } from "react-redux";
import { setToast } from "storeRedux/slices/toast";
import { useLangContext } from "context/Lang";
import { ReplaceWords } from "utils/ReplaceWords";
import { RootStateType } from "storeRedux/store";
import { OtherPlayer } from "./OtherPlayer";
import { AvatarPlayer } from "./avatar-player";





interface RemoteUser {
    userId: string | number;
    position: { x: number; y: number; z: number };
    rotation: number;
    avatarColors:any;
    isMoving?:boolean
}


interface VRPlayerProps extends WebSocketDataProps {
    colors?: AvatarColors;
}


export const VRPlayer = ({
    enableWebSocket,
    webSocketData,
    colors
}:VRPlayerProps) => {
   
    return (
        <>
            <DesktopControls 
                enableWebSocket={enableWebSocket}
                webSocketData={webSocketData}
                colors={colors}
            />
        </>
    );
};

const DesktopControls = ({ enableWebSocket, webSocketData,colors }: WebSocketDataProps&{colors?: AvatarColors;} ) => {
    const { gl, scene } = useThree();
    const { camera , setDoPlay } = useCanvasContext();

    const [remoteUsers, setRemoteUsers] = useState<{ [key: string]: RemoteUser }>({});

    const [client, setClient] = useState<Client | null>(null);

    const {user} = useSelector((state:RootStateType)=>state.auth); 
    const [isMoving,setIsMoving] = useState<boolean>(false);

    const dispatch = useDispatch(); 

    const { gW } = useLangContext();

    const keys = useRef<{ [key: string]: boolean }>({});
    const isLocked = useRef(false);

    // زوايا دوران الكاميرا المدارية حول اللاعب
    const pitch = useRef(0.3); 
    const yaw = useRef(0);

    const playerRef = useRef<THREE.Mesh>(null);

    const velocityY = useRef(0); 
    const isJumping = useRef(false);

    const GRAVITY = -25; 
    const JUMP_FORCE = 8; 

    


    const PLAYER_HALF_HEIGHT = 0.15; 
    const currentGroundY = useRef(PLAYER_HALF_HEIGHT); 

    const CAMERA_DISTANCE = 5; 
    const CAMERA_HEIGHT_OFFSET = 1.2; 

    const rayCaster = useRef(new THREE.Raycaster(new THREE.Vector3(), new THREE.Vector3(0, -1, 0), 0, 20));

    const lastSentPosition = useRef(new THREE.Vector3());
    const lastSendTime = useRef(0);




    useEffect(() => {
        const socketURL = process.env.REACT_APP_SOCKET_URL as string  ;
        if (enableWebSocket && socketURL) {
            const client = new Client({
                connectHeaders: {
                    "Authorization": axios.defaults.headers.common["Authorization"] as string || ""
                },
                webSocketFactory: () => new SockJS(socketURL),
                onConnect:(frame)=>{
                    client.publish({
                        destination: ReplaceWords(routes.ws.checkMapAccess.publish,{id:webSocketData?.mapId}), 
                    });



                    client.subscribe(routes.ws.checkMapAccess.subscribe,(message)=>{


                        if(message.body){
                            const data = JSON.parse(message.body);
                            if(data?.success===false){

                                dispatch(setToast({ severity: "error", detail: gW(data?.message)  }));
                                client.deactivate();  
                                setClient(null);
                                setDoPlay && setDoPlay(false);
                                return;
                            }else {
                                if(data?.oldUsers ){
                                    const temOldUsers:{ [key: string]: RemoteUser } = {};

                                    (data?.oldUsers as any[] )?.forEach(user=>{
                                        temOldUsers[String(user?.userId)] = user;
                                    });

                                    setRemoteUsers(temOldUsers);
                                }

                                client.publish({
                                    destination: ReplaceWords(routes.ws.liveMap.publish, { id: webSocketData?.mapId }),
                                    body: JSON.stringify({
                                        userId: user?.id,
                                        avatarColors:colors,
                                        position: {
                                            x: 10,
                                            y:2,
                                            z: 10
                                        },
                                    })
                                });
                                client?.subscribe(ReplaceWords(routes.ws.liveMap.subscribe,{id:webSocketData?.mapId}),(message)=>{
                                    if(message.body){
                                        const data = JSON.parse(message.body);
                                        if(data?.success!==false){
                                            const incomingData = data;

                                            if (String(incomingData.userId) === String(user?.id)) return;

                                            setRemoteUsers((prevUsers) => ({
                                                ...prevUsers,
                                                [incomingData.userId]: {
                                                    ...prevUsers[incomingData.userId]||{},
                                                    ...incomingData
                                                }
                                            }));

                                        }
                                    }else {
                                        
                                    }
                                })

                                

                                client?.subscribe(ReplaceWords(routes.ws.liveMapEvents.subscribe,{id:webSocketData?.mapId}),(message)=>{
                                    if(message.body){
                                        const data = JSON.parse(message.body);
                                        if(data?.success!==false){
                                            const eventData = data;

                                            if (eventData.action === "LEAVE") {
                                                const disconnectedUserId = eventData.userId;
                                                
                                                setRemoteUsers((prevUsers) => {
                                                    const updatedUsers = { ...prevUsers };
                                                    delete updatedUsers[disconnectedUserId]; 
                                                    return updatedUsers;
                                                });
                                                
                                            }

                                        }
                                    }else {
                                        
                                    }
                                })


                            }

                        }else {
                            client.deactivate();  
                            setClient(null);
                            setDoPlay && setDoPlay(false);
                        }
                    })
                   
                   
                },
                onDisconnect:()=>{
                    console.log("Disconnected from WebSocket server");
                },
                onStompError:(frame)=>{
                    console.error("STOMP error:", frame);
                    client.deactivate();
                }
            })

            client.activate();
            setClient(client);

            return () => {
                client&&client.deactivate();
                setClient(null);
            };
        }
    },[enableWebSocket,webSocketData]);






    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => {
            keys.current[e.code] = true;
        };

        const onKeyUp = (e: KeyboardEvent) => {
            keys.current[e.code] = false;
        };

        const onMouseMove = (e: MouseEvent) => {
            if (!isLocked.current) return;

            const sensitivity = 0.002;
            yaw.current -= e.movementX * sensitivity;
            pitch.current -= e.movementY * sensitivity;

            pitch.current = Math.max(-Math.PI / 4, Math.min(Math.PI / 3, pitch.current));
        };

        const onPointerLockChange = () => {
            isLocked.current = document.pointerLockElement === gl.domElement;
        };

        const onClick = () => {
            gl.domElement.requestPointerLock();
        };

        gl.domElement.addEventListener("click", onClick);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("pointerlockchange", onPointerLockChange);
        window.addEventListener("keydown", onKeyDown);
        window.addEventListener("keyup", onKeyUp);

        return () => {
            gl.domElement.removeEventListener("click", onClick);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("pointerlockchange", onPointerLockChange);
            window.removeEventListener("keydown", onKeyDown);
            window.removeEventListener("keyup", onKeyUp);
        };
    }, [camera, gl]);

    useFrame((_, delta) => {
        let speed = 4; 
        if (keys.current["ShiftLeft"]) {
            speed *= 1.8;
        }

        const direction = new THREE.Vector3();
        if (keys.current["KeyW"]) direction.z -= 1;
        if (keys.current["KeyS"]) direction.z += 1;
        if (keys.current["KeyA"]) direction.x -= 1;
        if (keys.current["KeyD"]) direction.x += 1;

        direction.normalize();
        
        if (camera?.current && playerRef.current) {
            
            const forward = new THREE.Vector3(0, 0, -1).applyAxisAngle(new THREE.Vector3(0, 1, 0), yaw.current);
            const right = new THREE.Vector3(1, 0, 0).applyAxisAngle(new THREE.Vector3(0, 1, 0), yaw.current);

            const move = new THREE.Vector3();
            move.add(forward.multiplyScalar(-direction.z));
            move.add(right.multiplyScalar(direction.x));
            if (move.lengthSq() > 0) move.normalize();


            let canMove = true;
            if (move.lengthSq() > 0) {
                client&&client.publish({
                    destination: ReplaceWords(routes.ws.liveMap.publish, { id: webSocketData?.mapId }),
                    body: JSON.stringify({
                        userId: user?.id,
                        isMoving:true
                    })
                });
                setIsMoving(true);
                const moveDirection = move.clone().normalize();
                const rayOrigin = playerRef.current.position.clone();
                // نطلق شعاع الفحص الأفقي من مركز اللاعب مباشرة
                const frontRaycaster = new THREE.Raycaster(rayOrigin, moveDirection, 0, 0.7);

                
                const objectsToIntersect = scene.children.filter(
                    (child) => child !== playerRef.current
                );

                const frontIntersections = frontRaycaster.intersectObjects(objectsToIntersect, true);
                

              
                const validHits = frontIntersections.filter(
                    hit => hit.object.type !== "PerspectiveCamera" &&hit.object.type !=="GridHelper"
                );


                
                if (validHits.length > 0) {
                    canMove = false; 
                }
            }else {
                setIsMoving(false);
                isMoving&&client&&client.publish({
                    destination: ReplaceWords(routes.ws.liveMap.publish, { id: webSocketData?.mapId }),
                    body: JSON.stringify({
                        userId: user?.id,
                        isMoving:false
                    })
                });
            }


           if (canMove) {
                playerRef.current.position.add(move.multiplyScalar(speed * delta));
                
                if (move.lengthSq() > 0) {
                    const targetAngle = Math.atan2(move.x, move.z);
                    
                    const rotationLerpFactor = 0.15; 
                    
                    playerRef.current.rotation.y = THREE.MathUtils.lerp(
                        playerRef.current.rotation.y,
                        targetAngle,
                        rotationLerpFactor
                    );
                }
            }

            rayCaster.current.ray.origin.copy(playerRef.current.position);
            rayCaster.current.ray.origin.y += 2.0;
            

            const objectsToIntersect = scene.children.filter(
                (child) => child !== playerRef.current
            );

            const intersections = rayCaster.current.intersectObjects(objectsToIntersect, true);
            
            const validGroundHits = intersections.filter(
                hit =>{
                    return  hit.object.type !== "PerspectiveCamera"
                } 
            );


            let targetGroundY = PLAYER_HALF_HEIGHT; 

            if (validGroundHits.length > 0) {
                const hit = validGroundHits[0];
                targetGroundY =  PLAYER_HALF_HEIGHT+hit.point.y; 
            }





            if (!isJumping.current) {
                currentGroundY.current = THREE.MathUtils.lerp(currentGroundY.current, targetGroundY, 0.2);
            } else {
                currentGroundY.current = targetGroundY;
            }
            

            if (keys.current["Space"] && !isJumping.current) {
                velocityY.current = JUMP_FORCE;
                isJumping.current = true;
            }
            

            if (isJumping.current || playerRef.current.position.y > currentGroundY.current) {

                velocityY.current += (GRAVITY * delta);

                playerRef.current.position.y += velocityY.current * delta;
            }


           
            
            if (playerRef.current.position.y <= currentGroundY.current ) {
                playerRef.current.position.y = currentGroundY.current;
                velocityY.current = 0;
                isJumping.current = false;

            } else if (isJumping.current && playerRef.current.position.y > currentGroundY.current) {
            
            }


            const targetCamX = playerRef.current.position.x + CAMERA_DISTANCE * Math.sin(yaw.current) * Math.cos(pitch.current);
            const targetCamZ = playerRef.current.position.z + CAMERA_DISTANCE * Math.cos(yaw.current) * Math.cos(pitch.current);
            const targetCamY = playerRef.current.position.y + CAMERA_HEIGHT_OFFSET + CAMERA_DISTANCE * Math.sin(pitch.current);

            camera.current.position.set(targetCamX, targetCamY, targetCamZ);

            const lookAtTarget = playerRef.current.position.clone();
            lookAtTarget.y += CAMERA_HEIGHT_OFFSET;
            camera.current.lookAt(lookAtTarget);

            
            if (client && client.connected) {
                const currentTime = performance.now();
                const currentPos = playerRef.current.position;
                
                const distanceMoved = currentPos.distanceTo(lastSentPosition.current);

                if (distanceMoved > 0.0001 && currentTime - lastSendTime.current > 20) {
                    
                    client.publish({
                        destination: ReplaceWords(routes.ws.liveMap.publish, { id: webSocketData?.mapId }),
                        body: JSON.stringify({
                            userId: user?.id,
                            position: {
                                x: parseFloat(currentPos.x.toFixed(3)),
                                y: parseFloat(currentPos.y.toFixed(3)),
                                z: parseFloat(currentPos.z.toFixed(3))
                            },
                            rotation: parseFloat(playerRef.current.rotation.y.toFixed(3)),
                        })
                    });

                    lastSentPosition.current.copy(currentPos);
                    lastSendTime.current = currentTime;
                }
            }

            
        }
    });

    return (<>
        
        <group ref={playerRef} position={[10, 2, 10]}>
            <AvatarPlayer
                isMoving={isMoving}
                colors={colors}
            />
        </group>

        {Object.values(remoteUsers).map((remoteUser) => (
            <OtherPlayer
                isMoving={remoteUser?.isMoving}
                colors={remoteUser?.avatarColors}
                key={remoteUser.userId} 
                position={remoteUser.position} 
                rotation={remoteUser.rotation} 
            />
        ))}
    </>
    );
};